import { Button, CircularProgress, Grid, MenuItem, TextField } from '@mui/material';
import React from 'react';

const Filters = ({
    isLoading,
    values,
    setFieldValue,
    touched,
    errors,
    handleChange,
    fetchBatches,
    fetchSchools,
    fetchtDepartments,
    fetchtPrograms,
    fetchSubjectDetails
}) => (
    <Grid spacing={2} container alignItems="center">
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="examId"
                name="examId"
                value={values?.examId}
                label="Select Exam *"
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('batchId', '');
                    setFieldValue('schoolId', '');
                    setFieldValue('departmentId', '');
                    setFieldValue('programId', '');
                    setFieldValue('semesterNo', 0);
                    setFieldValue('courseId', '');
                    setFieldValue('semesterStudentData', []);

                    fetchBatches(e.target.value);
                    fetchSchools(e.target.value);
                    const selectedExam = values?.examList?.find((elem) => elem?.id === e.target.value);
                    setFieldValue('examDetails', selectedExam);
                }}
                error={errors.examId && touched.examId && <div>{errors.examId}</div>}
                helperText={errors.examId && touched.examId && <div>{errors.examId}</div>}
            >
                <MenuItem value="">None</MenuItem>
                {values?.examList?.map((elem) => (
                    <MenuItem value={elem?.id}>{elem?.examName}</MenuItem>
                ))}
            </TextField>
        </Grid>
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="batchId"
                name="batchId"
                value={values?.batchId}
                label="Select Batch *"
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('schoolId', '');
                    setFieldValue('departmentId', '');
                    setFieldValue('programId', '');
                    setFieldValue('semesterNo', 0);
                    setFieldValue('courseId', '');
                    setFieldValue('semesterStudentData', []);
                }}
                error={errors.batchId && touched.batchId && <div>{errors.batchId}</div>}
                helperText={errors.batchId && touched.batchId && <div>{errors.batchId}</div>}
            >
                <MenuItem value="">None</MenuItem>
                {values?.batchList?.map((elem) => (
                    <MenuItem value={elem?.id}>{elem?.tag}</MenuItem>
                ))}
            </TextField>
        </Grid>
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="schoolId"
                name="schoolId"
                value={values?.schoolId}
                label="Select School *"
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('departmentId', '');
                    setFieldValue('programId', '');
                    setFieldValue('semesterNo', 0);
                    setFieldValue('courseId', '');
                    setFieldValue('semesterStudentData', []);

                    fetchtDepartments(values?.examId, e.target.value);
                }}
                error={errors.schoolId && touched.schoolId && <div>{errors.schoolId}</div>}
                helperText={errors.schoolId && touched.schoolId && <div>{errors.schoolId}</div>}
            >
                <MenuItem value="">None</MenuItem>
                {values?.schoolList
                    ?.sort((a, b) => {
                        const nameA = a?.name.trim().toLowerCase();
                        const nameB = b?.name.trim().toLowerCase();
                        return nameA?.localeCompare(nameB);
                    })
                    ?.map((elem) => (
                        <MenuItem value={elem?.id}>{elem?.name.toUpperCase()}</MenuItem>
                    ))}
            </TextField>
        </Grid>
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="departmentId"
                name="departmentId"
                value={values?.departmentId}
                label="Select Department *"
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('programId', '');
                    setFieldValue('semesterNo', 0);
                    setFieldValue('courseId', '');
                    setFieldValue('semesterStudentData', []);

                    fetchtPrograms(values?.batchId, e.target.value);
                }}
                error={errors.departmentId && touched.departmentId && <div>{errors.departmentId}</div>}
                helperText={errors.departmentId && touched.departmentId && <div>{errors.departmentId}</div>}
            >
                <MenuItem value="">None</MenuItem>
                {values?.departmentList
                    ?.sort((a, b) => {
                        const nameA = a?.name.trim().toLowerCase();
                        const nameB = b?.name.trim().toLowerCase();
                        return nameA?.localeCompare(nameB);
                    })
                    ?.map((elem) => (
                        <MenuItem value={elem?.departmentId}>{elem?.name.toUpperCase()}</MenuItem>
                    ))}
            </TextField>
        </Grid>
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="programId"
                name="programId"
                value={values?.programId}
                label="Select Program *"
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('semesterNo', 0);
                    setFieldValue('courseId', '');
                    setFieldValue('semesterStudentData', []);

                    const selectedProgram = values?.programList?.find((elem) => elem?.courseId === e.target.value);
                    setFieldValue('selectedProgram', selectedProgram);
                    setFieldValue('semesterList', selectedProgram?.course?.semesterNumber);
                    fetchSubjectDetails(values?.batchId, e.target.value, values?.examDetails?.semester);
                }}
                error={errors.programId && touched.programId && <div>{errors.programId}</div>}
                helperText={errors.programId && touched.programId && <div>{errors.programId}</div>}
            >
                <MenuItem value="">None</MenuItem>
                {values?.programList
                    ?.sort((a, b) => {
                        const nameA = a?.course.courseName.trim().toLowerCase();
                        const nameB = b?.course.courseName.trim().toLowerCase();
                        return nameA?.localeCompare(nameB);
                    })
                    ?.map((elem) => (
                        <MenuItem value={elem?.courseId}>{elem?.course?.courseName?.toUpperCase()}</MenuItem>
                    ))}
            </TextField>
        </Grid>
        {/* <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="semesterNo"
                name="semesterNo"
                value={values?.semesterNo}
                label={values?.selectedProgram?.semesterType === false ? 'Select Year *' : 'Select Semester *'}
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('courseId', '');
                    fetchSubjectDetails(values?.batchId, values?.programId, e.target?.value);
                }}
                error={errors.semesterNo && touched.semesterNo && <div>{errors.semesterNo}</div>}
                helperText={errors.semesterNo && touched.semesterNo && <div>{errors.semesterNo}</div>}
            >
                {Array.from({ length: values?.semesterList }, (x, i) => i).map((elem) => (
                    <MenuItem value={elem + 1}>{elem + 1}</MenuItem>
                ))}
            </TextField>
        </Grid> */}
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="courseId"
                name="courseId"
                value={values?.courseId}
                label="Select Course *"
                onChange={(e) => {
                    handleChange(e);
                    setFieldValue('semesterStudentData', []);
                    const selectedSubjectDetail = values?.courseList?.find((elem) => elem?.subjectId === e.target.value);
                    setFieldValue('selectedSubjectDetail', selectedSubjectDetail?.id);
                }}
                error={errors.courseId && touched.courseId && <div>{errors.courseId}</div>}
                helperText={errors.courseId && touched.courseId && <div>{errors.courseId}</div>}
            >
                <MenuItem value="">None</MenuItem>
                {values?.courseList
                    ?.filter((c) => c?.status)
                    ?.sort((a, b) => {
                        const nameA = a?.subjectMini?.subjectName.trim().toLowerCase();
                        const nameB = b?.subjectMini?.subjectName.trim().toLowerCase();
                        return nameA?.localeCompare(nameB);
                    })
                    ?.map((elem) => (
                        <MenuItem value={elem?.subjectId}>{elem?.subjectMini?.subjectName?.toUpperCase()}</MenuItem>
                    ))}
            </TextField>
        </Grid>
        <Grid item md={3} xs={12} sm={4}>
            <TextField
                fullWidth
                select
                id="paperMode"
                name="paperMode"
                value={values?.paperMode}
                label="Select Paper Mode *"
                onChange={(e) => {
                    handleChange(e);
                }}
                error={errors.paperMode && touched.paperMode && <div>{errors.paperMode}</div>}
                helperText={errors.paperMode && touched.paperMode && <div>{errors.paperMode}</div>}
            >
                <MenuItem value="BACK">Back</MenuItem>
                <MenuItem value="REGULAR">Regular</MenuItem>
                <MenuItem value="IMPROVEMENT">Improvement</MenuItem>
            </TextField>
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2} alignItems="center">
            <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                startIcon={isLoading ? <CircularProgress size="1rem" sx={{ color: 'red' }} /> : undefined}
            >
                {isLoading ? 'Please Wait' : 'Search'}
            </Button>
        </Grid>
    </Grid>
);

export default Filters;
